import { unstable_ClassNameGenerator as ClassNameGenerator } from "@mui/material/className";

export const setupMUI = () => {
  ClassNameGenerator.configure((componentName) => {
    if (["MuiButtonBase", "MuiIconButton", "MuiSwitch"].includes(componentName)) {
      return `new-${componentName}`;
    }

    return componentName;
  });
};
